import { isFunction } from 'lodash';
import qs from 'query-string';
import getXyHeaders from '@/utils/getXyHeaders';
export async function asyncTrampoline(func) {
    let p = func;
    while (isFunction(p)) {
        p = await p();
    }
    return p;
}
const chunkHeadLength = 20;
function parseHead(head, headLength = chunkHeadLength) {
    let i = 0;
    while (i < headLength) {
        if (head[i] === 0) {
            break;
        }
        i = i + 1;
    }
    return head.subarray(0, i);
}
const decode = (data) => {
    const decoder = new TextDecoder();
    return decoder.decode(data);
};
const parseChunk = (chunk) => {
    const pureHead = parseHead(chunk);
    const head = JSON.parse(decode(pureHead));
    const body = chunk.subarray(chunkHeadLength, chunkHeadLength + head.l);
    return { head, body };
};
// {"l":xxxx } 0000..00 gzip()
export const streamRequest = async (url, { headers, query, onChunk, onEnd, ...config }) => {
    const mergedQuery = { ...query, chunkHeadLength };
    const customHeaders = getXyHeaders();
    const res = await fetch(`${url}?${qs.stringify(mergedQuery)}`, {
        ...config,
        headers: { ...customHeaders, ...headers },
    });
    const reader = res.body.getReader();
    let stashChunk;
    let chunkIdx = 0;
    const consume = async (chunk) => {
        let mergedChunk = chunk;
        if (stashChunk) {
            mergedChunk = new Uint8Array(stashChunk.length + chunk.length);
            mergedChunk.set(stashChunk, 0);
            mergedChunk.set(chunk, stashChunk.length);
            stashChunk = undefined;
        }
        if (mergedChunk.length < chunkHeadLength) {
            stashChunk = mergedChunk;
            return;
        }
        while (mergedChunk.length > chunkHeadLength) {
            const { head, body } = parseChunk(mergedChunk);
            // 数据不全无法解析
            if (body.length < head.l) {
                break;
            }
            const chunkData = JSON.parse(decode(body));
            await onChunk?.(chunkData, { index: chunkIdx });
            chunkIdx = chunkIdx + 1;
            mergedChunk = mergedChunk.subarray(head.l + chunkHeadLength);
        }
        // 暂存剩余chunk
        if (mergedChunk.length) {
            stashChunk = mergedChunk;
        }
    };
    const receive = async () => {
        const { done, value } = await reader.read();
        if (done) {
            onEnd?.();
            return;
        }
        await consume(value);
        return receive;
    };
    await asyncTrampoline(receive);
};
/**
 * NDJSON 流式请求处理
 * 用于处理以换行符分隔的 JSON 数据流
 */
export const ndjsonStreamRequest = async (url, { headers, query, onLine, onEnd, ...config }) => {
    const customHeaders = getXyHeaders();
    const queryString = query ? `?${qs.stringify(query)}` : '';
    const res = await fetch(`${url}${queryString}`, {
        ...config,
        headers: { ...customHeaders, ...headers },
    });
    if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    const receive = async () => {
        const { done, value } = await reader.read();
        if (done) {
            // 处理最后可能剩余的数据
            if (buffer.trim()) {
                try {
                    const data = JSON.parse(buffer);
                    await onLine?.(data);
                }
                catch (e) {
                    console.error('Failed to parse last line:', buffer, e);
                }
            }
            await onEnd?.();
            return;
        }
        // 将新数据添加到缓冲区
        buffer += decoder.decode(value, { stream: true });
        // 按行分割并处理
        const lines = buffer.split('\n');
        // 保留最后一行（可能不完整）
        buffer = lines.pop() || '';
        // 处理完整的行
        for (const line of lines) {
            const trimmedLine = line.trim();
            if (trimmedLine) {
                try {
                    const data = JSON.parse(trimmedLine);
                    await onLine?.(data);
                }
                catch (e) {
                    console.error('Failed to parse NDJSON line:', trimmedLine, e);
                }
            }
        }
        return receive;
    };
    await asyncTrampoline(receive);
};
